<template>
  <div id="search-input" :style="'width: ' + width">
    <input
      type="text"
      :value="localValue"
      :style="inputStyle"
      :placeholder="placeholder"
      @input="onInput"
    />
    <div id="list" v-if="list && list.length > 0">
      <ul>
        <li v-for="(value, index) in list" :key="index" @click="select(value)">{{ value }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'

export default {
  name: 'search-input',
  props: [
    'defaultFilter',
    'placeholder',
    'inputStyle',
    'readField',
    'basePath',
    'initData',
    'filter',
    'width',
    'debounceWait',
    'debounceLeading',
    'debounceTrailing',
    'debounceMaxWait',
    'value',
    'uppercase'
  ],
  created () {
    this.debouncedGetAnswer = _.debounce(
      this.listData,
      this._debounceWait,
      {
        leading: this._debounceLeading,
        trailing: this._debounceTrailing,
        maxWait: this._debounceMaxWait
      }
    )
  },
  beforeDestroy () {
    if (this.debouncedGetAnswer && this.debouncedGetAnswer.cancel) {
      this.debouncedGetAnswer.cancel()
    }
  },
  computed: {
    _debounceWait () { return this.debounceWait || 500 },
    _debounceLeading () { return this.debounceLeading !== undefined ? this.debounceLeading : false },
    _debounceTrailing () { return this.debounceTrailing !== undefined ? this.debounceTrailing : true },
    _debounceMaxWait () { return this.debounceMaxWait || 5000 },

    localValue: {
      get () { return this.value != null ? this.value : this.data },
      set (v) {
        this.data = v
        this.$emit('input', v)
      }
    }
  },
  watch: {
    initData: {
      immediate: true,
      handler () {
        const base = this.value != null ? this.value : this.data
        if (this.initData !== base) {
          const v = this.initData || ''
          this.data = v
          this.$emit('input', v)
          if (v && v.length > 0) {
            this.listData()
          }
        }
      }
    }
  },
  data () {
    return {
      data: '',
      list: []
    }
  },
  methods: {
    ...mapActions({ getList: 'listes/list' }),
    async listData () {
      const q = (this.localValue || '').trim()
      if (!q) {
        this.list = []
        return
      }
      this.$emit('loading', true)
      try {
        const response = await this.getList({
          path: this.basePath,
          filters: Object.assign({ [this.filter]: q }, this.defaultFilter || {})
        })
        this.list = response.list || []
      } finally {
        this.$emit('loading', false)
      }
    },
    onInput (e) {
      let v = e.target.value
      if (this.uppercase) v = (v || '').toUpperCase()

      this.localValue = v
      if (!v.trim()) {
        this.list = []
        this.$emit('data', v)
        return
      }
      this.debouncedGetAnswer()
    },
    select (value) {
      const v = this.uppercase ? String(value || '').toUpperCase() : String(value || '')
      this.localValue = v
      this.list = []
      this.$emit('data', v)
    }
  }
}
</script>

<style scoped lang="scss">
#search-input{
    position: relative;
}
input{
    width: 100%;
}
input:focus + #list{
    visibility: visible;
    opacity: 1;
}
#list{
    visibility: hidden;
    opacity: 0;
    transition: visibility 0.2s, opacity 0.2s ease-out;
    position: absolute;
    width: 100%;
    border: 2px solid #CCCCCC;
    border-bottom-left-radius: .6em;
    border-bottom-right-radius: .6em;
    overflow: auto;
    padding: .4em;
    max-height: 10em;
    background: white;
    box-sizing: border-box;
    z-index: 99999;
}
ul{
    list-style: none;
}
li{
    padding: .3em;
    border-radius: .4em;
    transition: all 0.1s;
    cursor: pointer;
    &:hover{
        background: #C9D70A;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/SearchInput.vue